import React from 'react';
import IndexRouter from "./routers";
import ProjectProvider from "./context/projectProvider";
import { TimeoutProvider } from './components/SessionTimeoutProvider';
import { MsalProvider } from "@azure/msal-react";

const App = ({ msalInstance }) => {
  return (
    <MsalProvider instance={msalInstance}>
      <TimeoutProvider>
        <ProjectProvider>
          <IndexRouter />
        </ProjectProvider>
      </TimeoutProvider>
    </MsalProvider>
  );
};

export default App;